<template>
  <div class="container-full">
    <div class="header">

        <p class="title">
            <img src="img/logo.png" width="40" class="mb-2">
            SIPP Limbah B3
        </p>
        <a href="#/login" class="btn text-green fw-bold">
            Masuk ke Akunmu<i class="fa fa-sign-in ml-2"></i>
        </a>
    </div>
    <b-card class="m-3">
      <div class="display-table full-width mb-2">
        <strong class="card-title">Dashboard Utama</strong>
      </div>
      <b-row>
        <b-col md="4" class="d-flex mb-2">
            <b-form-group label="Tanggal Awal" class="m-1 w-100">
				<b-form-input type="date" v-model="models.startDate" @change="getData" >
				</b-form-input>
			</b-form-group>
            <b-form-group label="Tanggal Akhir" class="m-1 w-100">
				<b-form-input type="date" v-model="models.endDate" @change="getData">
				</b-form-input>
			</b-form-group>
        </b-col>
        <div class="w-100"></div>
        <b-col md="12" class="mb-3">
            <p class="subtitle">Data Pengumpulan Sampah / Limbah B3</p>
            <div class="row">
                <div class="col-sm-3 col-md-3">
                    <a href="" class="card-link">
                        <div class="card text-white bg-warning">
                            <div class="card-body">
                                <h1 class="text-center">{{persentage.kelurahan}}%</h1>
                            </div>
                            <div style="color:white" class="card-header text-center">Kelurahan</div>
                        </div>
                    </a>
                </div>
                <div class="col-sm-3 col-md-3">
                    <a href="" class="card-link">
                        <div class="card text-white bg-success">
                            <div class="card-body">
                                <h1 class="text-center">{{jmlSampah.rumahTangga}} Ton</h1>
                            </div>
                            <div style="color:white" class="card-header text-center">Rumah Tangga</div>
                        </div>
                    </a>
                </div>
                <div class="col-sm-3 col-md-3">
                    <a href="" class="card-link">
                        <div class="card text-white bg-danger">
                            <div class="card-body">
                                <h1 class="text-center">{{jmlSampah.umk}} Ton</h1>
                            </div>
                            <div style="color:white" class="card-header text-center">UMK</div>
                        </div>
                    </a>
                </div>
            </div>
        </b-col>
        <b-col md="12" class="mb-3">
            <p class="subtitle">Data Sampah / Limbah B3 yang Terkelola</p>
            <div class="row">
                <div class="col-sm-3 col-md-3">
                    <a href="" class="card-link">
                        <div class="card text-white bg-info">
                            <div class="card-body">
                                <h1 class="text-center">{{jmlSampah.rumahTangga }} Ton</h1>
                            </div>
                            <div style="color:white" class="card-header text-center">Rumah Tangga</div>
                        </div>
                    </a>
                </div>
                <div class="col-sm-3 col-md-3">
                    <a href="" class="card-link">
                        <div class="card text-white bg-info">
                            <div class="card-body">
                                <h1 class="text-center">{{jmlSampah.umk }} Ton</h1>
                            </div>
                            <div style="color:white" class="card-header text-center">UMK</div>
                        </div>
                    </a>
                </div>
                <div class="col-sm-3 col-md-3">
                    <a href="" class="card-link">
                        <div class="card text-white bg-info">
                            <div class="card-body">
                                <h1 class="text-center">{{jmlSampah.fasyankes }} Ton</h1>
                            </div>
                            <div style="color:white" class="card-header text-center">Fasyankes</div>
                        </div>
                    </a>
                </div>
                <div class="col-sm-3 col-md-3">
                    <a href="" class="card-link">
                        <div class="card text-white bg-info">
                            <div class="card-body">
                                <h1 class="text-center">{{jmlSampah.pelakuUsaha }} Ton</h1>
                            </div>
                            <div style="color:white" class="card-header text-center">Pelaku Usah</div>
                        </div>
                    </a>
                </div>
            </div>
        </b-col>

        <b-col md="6" class="mb-5">
            <p class="subtitle text-center">Persentase Sampah/Limbah B3 Per Sektor</p>
            <PersentaseLimbahSector/>
        </b-col>
         <b-col md="6" class="mb-5">
            <p class="subtitle text-center">Persentase Sampah/Limbah B3 Per Wilayah</p>
            <PersentaseLimbahWilayah :models="models"/>
        </b-col>
        <b-col md="12">
            <div class="d-md-flex d-sm-block align-items-center justify-content-center mb-4">
                <b-button variant="primary" @click="getMaps('rt')" class="w-100 my-1">Rumah Tangga</b-button>
                <b-button variant="primary" @click="getMaps('fasyankes')" class="w-100 my-1">Fasyankes</b-button>
                <b-button variant="primary" @click="getMaps('pelakuUsaha')" class="w-100 my-1">Pelaku Usaha</b-button>
            </div>
        </b-col>
        <b-col md="8" class="mx-auto" id="map" :style="{ height: '500px' }"></b-col>
      </b-row>
    </b-card>
  </div>
</template>
<style>
.chart{
  width: 100%;
  overflow: scroll;
}
.header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.25rem;
    background: #fff;
    border-bottom: 1px solid #b3b3b3;
}
.header p.title{
    margin: 0;
    font-size: 22px;
    font-weight: bold;
    color: #28833b;
    text-transform: uppercase;
    font-family: Helvetica, Arial, sans-serif;
}
.subtitle{
    font-weight: 900;
    font-family: Helvetica, Arial, sans-serif;
    font-size: 16px;

}
.text-green{
    color: #28833b;
}
#map {
  height: 100%;
  width: 100%;
}
</style>

<script>
  import L from 'leaflet';
  import 'leaflet/dist/leaflet.css';
  import markerIcon from "leaflet/dist/images/marker-icon.png";
  import markerShadow from "leaflet/dist/images/marker-shadow.png";
  import PersentaseLimbahSector from './persentase_limbah_sector';
  import PersentaseLimbahWilayah from './dsb_main_persentase_limbah_wilayah';
  import moment from 'moment';
  export default {
    name: 'dashboard',
    components: {
      PersentaseLimbahSector,
      PersentaseLimbahWilayah
    },
    data: function () {
      return {
        map: null,
        models: {
            startDate: moment().startOf('month').format('YYYY-MM-DD'),
            endDate: moment().endOf('month').format('YYYY-MM-DD'),
        },
        persentage: {
            kelurahan: 0
        },
        jmlSampah: {
            rumahTangga: 0,
            umk: 0,
            fasyankes: 0,
            pelakuUsaha: 0
        },
        mapsMarkers: []
      }
    },
    mounted(){
        this.getData();
    },
    methods: {
        getData(){
            const _ = this;
            if(_.models.startDate && _.models.endDate){
                _.getPersenstaseKelurahan();
                _.getJmlSampahRt();
                _.getJmlSampahUmk();
                _.getJmlSampahFasyankes();
                _.getJmlSampahPelakuUsaha();
                _.getMaps();
            }
        },
        getPersenstaseKelurahan(){
            const _ = this;
            _.$axios.get('DashboardMain/PersentaseKelurahan', {
                params: {
                    startDate: _.models.startDate,
                    endDate: _.models.endDate
                }
            })
            .then(res => {
                _.persentage.kelurahan = res.data.data.length ? res.data.data[0].dshbrdMainKelurahanPercentage : 0;
            })
        },
        getJmlSampahRt(){
            const _ = this;
            _.$axios.get('DashboardMain/JumlahSampahRumahTangga', {
                params: {
                    startDate: _.models.startDate,
                    endDate: _.models.endDate
                }
            })
            .then(res => {
                _.jmlSampah.rumahTangga = res.data.data.length ? res.data.data[0].dshbrdMainSampahRT : 0;
            })
        },
        getJmlSampahFasyankes(){
            const _ = this;
            _.$axios.get('DashboardMain/JumlahSampahTerkelolaFasyankes', {
                params: {
                    startDate: _.models.startDate,
                    endDate: _.models.endDate
                }
            })
            .then(res => {
                _.jmlSampah.fasyankes = res.data.data.length ? res.data.data[0].dshbrdMainSampahTerkelolaFasyankes : 0;
            })
        },
        getJmlSampahUmk(){
            const _ = this;
            _.$axios.get('DashboardMain/JumlahSampahUMK', {
                params: {
                    startDate: _.models.startDate,
                    endDate: _.models.endDate
                }
            })
            .then(res => {
                _.jmlSampah.umk = res.data.data.length ? res.data.data[0].dshbrdMainSampahUMK : 0;
            })
        },
        getJmlSampahPelakuUsaha(){
            const _ = this;
            _.$axios.get('DashboardMain/JumlahSampahTerkelolaPelakuUsaha', {
                params: {
                    startDate: _.models.startDate,
                    endDate: _.models.endDate
                }
            })
            .then(res => {
                _.jmlSampah.pelakuUsaha = res.data.data.length ? res.data.data[0].dshbrdMainSampahTerkelolaPelakuUsaha : 0;
            })
        },
        getMaps(type = 'rt'){
            const _ = this;
            let url = "";
            let field = "";
            switch (type) {
                case 'rt':
                    url = "MapsSampahRumahTangga";
                    field = "pengumpulanSampahRT";
                    break;
                case 'pelakuUsaha':
                    url = "MapsPelakuUsaha";
                    field = "limbah";
                    break;
                case 'fasyankes':
                    url = "MapsFasyankes";
                    field = "limbah";
                    break;
            }
            _.$axios.get('DashboardMain/' + url, {
                params: {
                    startDate: _.models.startDate,
                    endDate: _.models.endDate
                }
            })
            .then(res => {
                _.mapsMarkers = res.data.data;
                _.initMap(field);
            })
        },
        initMap(field){
            const _ = this;
            // Initialize the map
            if (_.map) {
                _.map.remove();
            }

            _.map = L.map('map').setView([-6.2088, 106.8456], 13);

            // Add OpenStreetMap tiles
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            }).addTo(_.map);

            // Set custom marker icon
            const customIcon = L.icon({
                iconUrl: markerIcon,
                shadowUrl: markerShadow,
                iconSize: [25, 41], // Default Leaflet icon size
                iconAnchor: [12, 41], // Anchor the icon properly
            });
            
            // Add a marker
            _.mapsMarkers.forEach((marker) => {
                const newMarker = L.marker([marker.longitude, marker.latitude], { icon: customIcon }).addTo(_.map);

                // Add popup if provided
                if (marker[field]) {
                    newMarker.bindPopup("Total: " + marker[field]).openPopup();
                }
            });
            // newMarker.openPopup();
        }
    },
    beforeUnmount() {
        // Clean up the map instance when the component is destroyed
        if (this.map) {
            this.map.remove();
        }
    },
  }
</script>